import { Route, Routes } from 'react-router-dom';
import AboutPage from './components/Pages/AboutPage';
import ContactPage from './components/Pages/ContactPage';
import ErrorPage from './components/Pages/ErrorPage';
import ServicesPage from './components/Pages/ServicesPage';
import DigitalAgencyHome from './components/Pages/DigitalAgencyHome';
import Layout from './components/Layout';
import FaqPage from './components/Pages/FaqPage';
import ToSPage from './components/Pages/ToSPage';
import PrivacyPolicyPage from './components/Pages/PPPage';
import UiUxDesignPage from "./components/Pages/UiUxPage";
import WebDevelopmentPage from "./components/Pages/WebDevelopmentPage";
import Office365Page from "./components/Pages/o365page";
import DigitalMarketingPage from "./components/Pages/DigitalMarketingPage";
import TechnologyPage from "./components/Pages/TechnologyPage";
import ConsultancyPage from "./components/Pages/ConsultancyPage";
import CreativeDesignPage from "./components/Pages/CreativeDesignPage";
function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<DigitalAgencyHome />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="services/o365" element={<Office365Page />} />
          <Route path="services/ui-ux-design" element={<UiUxDesignPage />} />
          <Route path="services/web-development" element={<WebDevelopmentPage />} />
          <Route path="services/digital-marketing" element={<DigitalMarketingPage />} />
          <Route path="services/technology" element={<TechnologyPage />} />
          <Route path="services/consultancy" element={<ConsultancyPage />} />
          <Route path="services/creative-design" element={<CreativeDesignPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="terms-of-service" element={<ToSPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
